<div *ngIf="showForm" class="mt-4 container-fluid my-5 text-center">
    <h3>Thank you! Your information has been received.</h3>
    <div>An activation link will be sent to you via email shortly.</div>
    <div>If you do not receive the email, please check your spam folder to see if it is there.</div>
</div>
